export const vacationDataEN = {
  accumulated_days: 'Accumulated days',
  annulation_date: 'Annulation date',
  day_off_type: 'Type of day off',
  days_to_burn: 'Days to burn',
  estimation_period: 'Estimation period',
  last_update: 'Last update',
  paid_vacations: 'Paid Vacations',
  unpaid_day_offs: 'Unpaid Day-offs',
  info_sign_text: {
    vacation_days_left:
      '<b>Vacation days left</b> - Accumulated days available for booking based on the Last update',
    accumulated_days:
      '<b>Accumulated Days</b> - All accumulated days (including used) based on the Estimation period. This number can help you to predict the number of days that should still be accumulated in the current period.',
    days_to_burn:
      '<b>Days to Burn</b> - All possible days that can be accumulated in one period (year) minus used vacation days. This number even includes days that have not been accumulated yet but will be in the future. Such a record will help you to understand the number of days that are going to burn on the Annulation date.',
  },
} as const;
